import {css} from "styled-components";
import {fontWeight} from "./styles";

export type Weight = "regular" | "medium" | "bold";
export type Size =
    | "xx-small"
    | "x-small"
    | "small"
    | "medium"
    | "large"
    | "x-large"
    | "custom-large";

type BaseSizesProps = {
    $size?: Size;
};
export const baseSizes = css<BaseSizesProps>`
  ${props =>
    props.$size === "xx-small" &&
    css`
      font-size: 11px;
      line-height: 1;
        font-size-adjust: none;
    `}
  ${props =>
    props.$size === "x-small" &&
    css`
      font-size: 14px;
      line-height: 1;
      font-size-adjust: none;
    `}
  ${props =>
    props.$size === "small" &&
    css`
      font-size: 16px;
      line-height: 1;
      font-size-adjust: none;
    `}
  ${props =>
    props.$size === "medium" &&
    css`
      font-size: 18px;
      line-height: 24px;
      font-size-adjust: none;
    `}
  ${props =>
    props.$size === "large" &&
    css`
      font-size: 24px;
      line-height: 32px;
      font-size-adjust: none;
    `}
  ${props =>
    props.$size === "x-large" &&
    css`
      font-size: 40px;
      line-height: 1;
      font-size-adjust: none;
    `}

  ${props =>
          props.$size === "custom-large" &&
          css`
      font-size: 27px;
      line-height: 27px;
      font-size-adjust: none;
    `}

  ${props =>
          props.$size === "x-large" &&
          css`
              @media screen and (max-width: 767px) {
                  font-size: 28px;
                  line-height: 1;
                  font-size-adjust: none;
              }
      `}

`;
type BaseWeightsProps = {
    $weight?: Weight;
};
export const baseWeights = css<BaseWeightsProps>`
  ${props =>
    props.$weight === "regular" &&
    css`
      font-weight: ${fontWeight.normal};
    `}
  ${props =>
    props.$weight === "medium" &&
    css`
      font-weight: ${fontWeight.medium};
    `}
  ${props =>
    props.$weight === "bold" &&
    css`
      font-weight: ${fontWeight.bold};
    `}
`;

type BoldFontSizeAdjustmentProps = {
    $size?: Size;
    $weight?: Weight;
};
export const boldFontSizeAdjustment = css<BoldFontSizeAdjustmentProps>`
  ${props =>
    props.$size === "medium" &&
    props.$weight === "bold" &&
    css`
      font-size: 20px;
    `}
`;

type BoldFontTransformAdjustmentProps = {
    $size?: Size;
    $weight?: Weight;
};
export const boldFontTransformAdjustment = css<BoldFontTransformAdjustmentProps>`
  ${props =>
    props.$weight === "bold" &&
    (props.$size === "small" ||
        props.$size === "x-small" ||
        props.$size === "xx-small") &&
    css`
      text-transform: uppercase;
    `}
`;